import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

const shareMsg = (pct) => `The Lokal is offering ${pct}% off custom wine experiences. Use my link to submit your order within 72 hours, and I'll receive a referral credit. Adults 19+ only.`;

const CampaignConfirm = ({ basePath = '' }) => {
  const location = useLocation();
  const [data, setData] = useState(location.state || null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!data) {
      const stored = sessionStorage.getItem('ff_lokal_last_order');
      if (stored) setData(JSON.parse(stored));
    }
  }, [data]);

  if (!data?.emailConfirmed || data?.emailStatus !== 'sent') {
    return (
      <div className="ff-section" data-testid="ff-thankyou-missing">
        <div className="ff-container ff-text-center">
          <h1 className="ff-serif">No confirmed request found</h1>
          <p>Return to the form to submit your request.</p>
          <Link className="ff-btn ff-btn-primary" data-testid="ff-thankyou-return" to={`${basePath}/order`}>Return to the form</Link>
        </div>
      </div>
    );
  }

  const url = data.referralUrl || '';
  const pct = Math.round(Number(data.campaignDiscount ?? data.discount ?? 15));
  const share = `${shareMsg(pct)} ${url}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (err) {
      console.error('Clipboard copy failed:', err);
    }
  };

  const shareBySms = () => window.open(`sms:?body=${encodeURIComponent(share)}`);
  const shareByEmail = () =>
    window.open(`mailto:?subject=${encodeURIComponent(`Save ${pct}% on Your Wine Experience with The Lokal`)}&body=${encodeURIComponent(share)}`);
  const shareOnFacebook = () =>
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank', 'noopener,noreferrer');

  return (
    <div className="ff-section" data-testid="ff-thankyou">
      <div className="ff-container ff-form-shell">
        <h1 className="ff-serif ff-text-center" data-testid="ff-thankyou-headline">
          Your Wine Experience Request Is In
        </h1>
        <p className="ff-lede">
          Thank you for choosing The Lokal. Your request has been received and saved. Our team will
          contact you to confirm your wine, pricing, and availability, and a confirmation email is on its way.
        </p>

        <div className="ff-confirmation-badge ff-text-center">
          <p style={{ margin: 0, fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--ff-brown-soft)' }}>
            Requested offer
          </p>
          <p style={{ margin: '6px 0 0', fontSize: 28, color: 'var(--ff-burgundy)' }}>
            <strong>{pct}% Off</strong>
          </p>
        </div>

        <section className="ff-card ff-mt-6" data-testid="ff-referral-block">
          <h2 className="ff-serif" style={{ marginTop: 0, fontSize: 24, textAlign: 'center' }}>
            Refer a Friend and Earn $25
          </h2>
          <p style={{ textAlign: 'center', color: 'var(--ff-brown-soft)' }}>
            Share your personalized referral link. When a new customer submits a qualifying order
            within 72 hours, they will receive {pct}% off and you will receive a $25 Lokal credit.
          </p>

          <div className="ff-referral-link ff-mt-4">
            <input
              readOnly
              value={url}
              data-testid="ff-referral-url"
              onFocus={(e) => e.target.select()}
            />
            <button className="ff-btn ff-btn-primary" data-testid="ff-copy-btn" onClick={copy} type="button">
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>

          <div className="ff-share-grid">
            <button type="button" className="ff-btn ff-btn-secondary" data-testid="ff-share-text" onClick={shareBySms}>
              Text
            </button>
            <button type="button" className="ff-btn ff-btn-secondary" data-testid="ff-share-email" onClick={shareByEmail}>
              Email
            </button>
            <button type="button" className="ff-btn ff-btn-secondary" data-testid="ff-share-facebook" onClick={shareOnFacebook}>
              Facebook
            </button>
            <a
              href="https://thelokal.ca"
              className="ff-btn ff-btn-gold"
              data-testid="ff-return-home"
            >
              TheLokal.ca
            </a>
          </div>

          <p style={{ fontSize: 12, color: 'var(--ff-brown-soft)', marginTop: 20, textAlign: 'center' }}>
            Referral credits are not redeemable for cash. Discounts cannot be combined unless approved by The Lokal.
            Promotional eligibility is subject to confirmation. Adults 19+ only.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CampaignConfirm;
